import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import PatientProfileImageEdit from './PatientProfileImageEdit';

interface Props extends BaseModalProps {
	patientId: string;
	onSuccess?: () => void;
}

const PatientProfileImageEditModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='component.patientProfileImageEdit.modalTitle'>
			<PatientProfileImageEdit
				patientId={props.patientId}
				onSuccess={props.onSuccess}
			/>
		</BaseModal>
	);
};

export default PatientProfileImageEditModal;
